<div class="badge">
  <div class="bg" [ngClass]="status.step.id">
    <span title="Status {{status.id}}">{{ status.step.name(config) }}</span>
  </div>
  <span class="complexity-icon"
        [ngClass]="{'complexity-low': complexity === 1, 'complexity-medium': complexity === 2, 'complexity-high': complexity === 3}"
        title="Complexity: {{complexity >= 1 && complexity <= 3 ? complexity : 'not calculated'}}"></span>
</div>
